import { gql } from "@apollo/client";

const GET_DOCUMENT_LIST = gql`
  query GET_DOCUMENT_LIST($hcpId: ObjectId, $hcfId: ObjectId, $shiftId: ObjectId) {
    documentList(hcpId: $hcpId, hcfId: $hcfId, shiftId: $shiftId) {
      _id
      name
      hcpId
      displayName
      issueDate
      expiry
      covidTest
      visible
      status
      state
      multiState
      subType
      createdAt
      uploadedFor {
        _id
        name
      }
      fulfilledRequirement {
        _id
        name
      }
      rejectionNotifiedAt
      notification {
        note
        pushNotification
        reason
      }
      requirement {
        expiryType
      }
    }
  }
`;

const UPDATE_HCP_DOCUMENT = gql`
  mutation UPDATE_HCP_DOCUMENT(
    $_id: ObjectId!
    $visible: Boolean
    $expiry: DateTime
    $issueDate: DateTime
    $covidTest: DateTime
    $status: HcpDocumentStatus
    $displayName: String
    $subType: String
    $state: String!
    $multiState: Boolean!
    $fulfilledRequirement: ObjectId
    $notification: NotificationInput
  ) {
    updateHcpDocument(
      _id: $_id
      expiry: $expiry
      issueDate: $issueDate
      covidTest: $covidTest
      status: $status
      visible: $visible
      displayName: $displayName
      state: $state
      subType: $subType
      multiState: $multiState
      fulfilledRequirement: $fulfilledRequirement
      notification: $notification
    ) {
      _id
      name
      displayName
      expiry
      issueDate
      covidTest
      visible
      status
      state
      multiState
      subType
      uploadedFor {
        _id
        name
      }
      fulfilledRequirement {
        _id
        name
      }
      notification {
        note
        pushNotification
        reason
      }
      rejectionNotifiedAt
    }
  }
`;

const DELETE_HCP_DOCUMENT = gql`
  mutation DELETE_HCP_DOCUMENT($_id: ObjectId!) {
    deleteHcpDocument(_id: $_id) {
      _id
      name
      displayName
      expiry
      visible
      status
      fulfilledRequirement {
        _id
        name
      }
    }
  }
`;

export { DELETE_HCP_DOCUMENT, GET_DOCUMENT_LIST, UPDATE_HCP_DOCUMENT };
